import type { LitElement } from 'lit'

const subscribers = new Set<LitElement>()

export function subscribe(el: LitElement): void {
  subscribers.add(el)
}

export function unsubscribe(el: LitElement): void {
  subscribers.delete(el)
}

export function notifySubscribers(): void {
  for (const el of subscribers) {
    el.requestUpdate()
  }
}
